<template>
    <div class="union-upload" :class="{'iscompressing': compressStatus == 1}" @click="preChange">
        <input type="file" accept="image/jpg,image/jpeg,image/png,image/gif" capture="camera"
        @change="handleChange" v-if="compressStatus != 1 && sourceType==2" />
        <input type="file" accept="image/*" @change="handleChange" v-if="compressStatus != 1 && sourceType != 2" />
        <i class="i-isgoing" v-else>上传中…</i>
    </div>
</template>
<style>
.union-upload{
    width: 100%;
    height: 100%;
    outline: 0;
    position: relative;
}
.union-upload input[type="file"]{
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    background: transparent;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
}
.union-upload .i-isgoing{
    display: none;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    font-size: 12px;
}
.union-upload.iscompressing input[type="file"]{
    display: none;
}
.union-upload.iscompressing .i-isgoing{
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-align: center;
    font-size: 12px;
    color: #959595;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    position: absolute;
    left: 0;
    top: 0;
}
</style>
<script>
import lrz from 'lrz'
export default {
    props: {
        // width: { //图片最大不超过的宽度，默认为原图宽度，高度不设时会适应宽度
        //     type: Number,
        //     // default: 
        // },
        // height: { //同上
        //     type: Number,
        //     // default: 
        // },
        quality: { //图片压缩质量，取值 0 - 1，默认为0.7
            type: Number,
            default: 0.5
        },
        // fieldName: { //后端接收的字段名，默认：file
        //     type: String,
        //     // default: ""
        // },
        btntext: { //按钮文字
            type: String,
            default: ""
        },
        maxfilesize: { //单文件最大容量
            type: Number,
            default: 1 //1M
        },
        sourceType: { //指定来源是相册还是相机,1:相册,2:相机,3:相册+相机
            type: Number,
            default: 3
        },
    },
    data(){
        return {
            // imgData: ""
            compressStatus: 0 //压缩进度，0:未开始,1:正在压缩,2:压缩成功,3:压缩失败 
        }
    },
    methods: {
        //压缩图片
        handleChange(e) {
            let self = this;
            if (!e.target.files[0]) {
                self.compressStatus = 0;
                return false;
            }
            self.compressStatus = 1;
            self.$emit("checkCompressStatus",self.compressStatus);
            lrz(e.target.files[0],{
                quality: self.quality
            })
            .then(function (rst) {
                if (rst.base64Len > 1024 * 1024 * parseInt(self.maxfilesize)) {
                    // self.imgData = '';
                    alert("图片不能超过"+ self.maxfilesize +"MB");
                    // self.$toast('图片不能超过1MB');
                    self.compressStatus = 3;
                    self.$emit("checkCompressStatus",self.compressStatus);
                    return false;
                }
                // self.imgData = rst.base64;
                // console.log(rst);
                let newImage = {
                    FilePath: rst.base64
                };
                self.compressStatus = 2;
                self.$emit("fileUploded", newImage);
            }).catch(function (err) {
                self.compressStatus = 3;
                alert("图片压缩失败");
                // self.$toast('压缩图片失败');
            });
        },
        //处理前
        preChange(){
            this.$emit("preChange");
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/shared/components/uploadfile/upload.vue